import { isGroupedRow, Message } from "@/reducers/messagesSlice"
import type { ChatRow } from "@/components/ChatHistory"

export const isVoiceMessage = (message: Message): boolean => {
  if (message.file !== true || !message.url) return false
  return (
    /\.oga|\.mp3|\.wav|\.m4a/i.test(message.url) ||
    (message.fileName
      ? /\.oga|\.mp3|\.wav|\.m4a/i.test(message.fileName)
      : false)
  )
}

// Utility function to check if a message row contains voice messages
export const rowHasVoiceMessages = (row: ChatRow): boolean => {
  if (typeof row === "symbol") return false // PlaceholderType

  return isGroupedRow(row)
    ? row.messages.some((message) => isVoiceMessage(message))
    : isVoiceMessage(row)
}

// Check if a row contains a specific message ID (for voice message keepMounted tracking)
export const rowContainsMessageId = (
  row: ChatRow,
  messageId: string,
): boolean => {
  if (typeof row === "symbol") return false

  return isGroupedRow(row)
    ? row.messages.some((message) => message.id === messageId)
    : row.id === messageId
}
